import DocumentShedule from './DocumentShedule'

export default DocumentShedule;